import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import Rating from "../rating";
import ProfileAvatar from "../../images/profile-avatar.png";
import { useGetTestimonialsQuery } from "../../store/testmonials";
import { generateFullImageUrl } from "../../utilities/utils";
import { Element } from "react-scroll";

const HelpMatchSlider = ({ title }) => {
  const [testimonials, setTestimonials] = useState([]);
  const isMobile =
    window.matchMedia &&
    window.matchMedia("only screen and (max-width: 640px)").matches;

  const { data: allTestimonials, isLoading } = useGetTestimonialsQuery();

  useEffect(() => {
    if (allTestimonials?.testimonials) {
      setTestimonials(allTestimonials?.testimonials);
    }
  }, [allTestimonials]);

  const slidesToShow =
    testimonials && testimonials.length < 3 ? testimonials.length : 3;

  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: testimonials?.length < 2 ? testimonials?.length : 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <Element name="say-helpMatch">
    <div>
      <div className="others pb-[100px] px-0">
        <div className="container">
          <div className="title-row">
            <h2 className="mb-[30px] md:mb-[63px] text-center md:text-left">
              {title}
            </h2>
          </div>
          <div className="detail-row">
            <div className="others-slider">
              <Slider {...settings}>
                {testimonials &&
                  testimonials?.map((item) => (
                    <div
                      className="item p-5 border border-solid border-[#CCD0D4] bg-white flex gap-[30px] rounded-[20px]"
                      key={item.id}
                    >
                      {isMobile ? (
                        <div>
                          <div className="item-detail flex items-center gap-5 mb-[25px]">
                            <div className="thumbnail w-[60px] h-[60px] rounded-[50%] overflow-hidden">
                              <img
                                src={
                                  item.photo
                                    ? generateFullImageUrl(item.photo)
                                    : ProfileAvatar
                                }
                                alt=""
                              />
                            </div>
                            <div className="detail w-[calc(100%-80px)]">
                              <span className="text-base font-bold leading-[160%] text-customGray">
                                {item.name}
                              </span>
                              <Rating rating={item.rating} />
                            </div>
                          </div>
                          <p className="text-sm font-normal leading-[160%] text-[#485868] h-[90px] overflow-hidden text-ellipsis line-clamp-4">
                            {item.description}
                          </p>
                        </div>
                      ) : (
                        <>
                          <div className="thumbnail w-[80px] h-[80px] rounded-[50%] overflow-hidden bg-gray-500">
                            <img
                              src={
                                item.photo
                                  ? generateFullImageUrl(item.photo)
                                  : ProfileAvatar
                              }
                              alt=""
                            />
                          </div>
                          <div className="detail w-full md:w-[calc(100%-110px)]">
                            <span className="text-lg font-bold leading-[160%] text-customGray mb-[10px]">
                              {item.name}
                            </span>
                            <p className="text-base font-normal leading-[160%] text-[#485868] mb-[30px] h-[177px] overflow-hidden text-ellipsis line-clamp-7">
                              {item.description}
                            </p>
                            <Rating rating={item.rating} />
                          </div>
                        </>
                      )}
                    </div>
                  ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </div>
    </Element>

  );
};

export default HelpMatchSlider;
